<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/point/table">零豆列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">描述</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="选项"
                          prop="reason">
              <el-select v-model="form.reason"
                         placeholder="请选择"
                         class="width-max">
                <el-option v-for="item in options.reason"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="描述"
                          prop="desc">
              <el-input type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        v-model="form.desc">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         native-type="submit">提交表单
              </el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../point.rules.js'

export default {
  components: {},
  data () {
    return {
      id: 0,
      formRules,
      form: {
        userid: this.$route.params.userid,
        reason: null,
        desc: null,
      },
      options: {
        reason: [
          {label: '提交虚假照片或造假', value: 104},
          {label: '发布与帖子无关的评论或者发布恶意言论', value: 105},
          {label: '恶意灌水、刷屏', value: 106},
        ],
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    onLoad () {
    },
    onReload () {
      Object.assign(this.$data, this.$options.data())
      this.onLoad()
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('deductPoint', this.form).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/users/table/'})
        })
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/point/pages/PointDeductForm.vue